exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-item[data-v-4a263f12]{color:#6e7687;display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[data-v-4a263f12]:focus,.dropdown-item[data-v-4a263f12]:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}", ""]);

// exports
